/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamCorrectionDashboardQueryResponse,
  GetApiV1ExamCorrectionDashboardQueryParams,
  GetApiV1ExamCorrectionDashboard400,
  GetApiV1ExamCorrectionDashboard401,
  GetApiV1ExamCorrectionDashboard500,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionDashboard.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamCorrectionDashboard } from "../../clients/examCorrectionDashboardController/getApiV1ExamCorrectionDashboard.ts";

export const getApiV1ExamCorrectionDashboardQueryKey = (
  params?: GetApiV1ExamCorrectionDashboardQueryParams,
) =>
  [
    { url: "/api/v1/exam/correction-dashboard" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamCorrectionDashboardQueryKey = ReturnType<
  typeof getApiV1ExamCorrectionDashboardQueryKey
>;

export function getApiV1ExamCorrectionDashboardQueryOptions(
  params?: GetApiV1ExamCorrectionDashboardQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamCorrectionDashboardQueryKey(params);
  return queryOptions<
    GetApiV1ExamCorrectionDashboardQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionDashboard400
      | GetApiV1ExamCorrectionDashboard401
      | GetApiV1ExamCorrectionDashboard500
    >,
    GetApiV1ExamCorrectionDashboardQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamCorrectionDashboard(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados do painel de controle de correção. **(Requer Authorization para autenticação)**
 * @summary Painel de correção (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correction-dashboard}
 */
export function useGetApiV1ExamCorrectionDashboard<
  TData = GetApiV1ExamCorrectionDashboardQueryResponse,
  TQueryData = GetApiV1ExamCorrectionDashboardQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamCorrectionDashboardQueryKey,
>(
  params?: GetApiV1ExamCorrectionDashboardQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamCorrectionDashboardQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamCorrectionDashboard400
          | GetApiV1ExamCorrectionDashboard401
          | GetApiV1ExamCorrectionDashboard500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamCorrectionDashboardQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ExamCorrectionDashboardQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionDashboard400
      | GetApiV1ExamCorrectionDashboard401
      | GetApiV1ExamCorrectionDashboard500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
